import { GuestHotelScheduleLiteModel } from 'api-hooks/cro/model';
import { useUpdateHotelSchedule } from 'api-hooks/cro/mutation';
import { ModelTransformer } from 'common/helpers/common';
import { ExtendedApiResult } from 'common/repositories/common.model';
import { queryClient } from 'common/repositories/query-client';
import notification from 'components/common/notification';
import { MasterInput } from 'components/elements/master';
import { debounce } from 'lodash';
import React from 'react';

interface HotelConfirmationCodeInputProps {
  original: GuestHotelScheduleLiteModel;
}

// optimistic
export default function HotelConfirmationCodeInput(
  props: HotelConfirmationCodeInputProps,
) {
  const storageKey = 'hotel-schedule-key';

  const fallbackStorageValue = "['get-guest-hotel-schedules']";

  const key = sessionStorage.getItem(storageKey);

  const mutate = useUpdateHotelSchedule;

  const queryKey = JSON.parse(key || fallbackStorageValue);

  // Snapshot the previous value
  const data = queryClient.getQueryData(queryKey) as ExtendedApiResult<any[]>;

  const original = ModelTransformer(
    data.data.find((value) => {
      return value.id === props.original.id;
    })!,
    GuestHotelScheduleLiteModel,
  ) as GuestHotelScheduleLiteModel;

  const id = props.original.id;

  const { mutateAsync } = mutate();

  const ref = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    if (ref.current) {
      ref.current.value = original.hotelConfirmationCode || '';
      ref.current.focus();
    }
  }, [original.hotelConfirmationCode]);

  return (
    <div
      style={{
        marginTop: -4,
      }}
      onClick={(e) => {
        e.preventDefault(); // stop bubbling on href
        e.stopPropagation(); // stop bubbling on component
      }}
    >
      <MasterInput
        noMargin
        inputRef={ref}
        clearable={false}
        onKeyUp={(event) => {
          debounce(async () => {
            try {
              if (!ref.current) return;

              const value = ref.current.value;
              ref.current?.focus();

              const result = data.data.map((item) => {
                if (item.id === id) {
                  return {
                    ...item,
                    hotelConfirmationCode: value,
                  };
                }
                return item;
              });
              queryClient.setQueryData(queryKey, {
                ...data,
                data: result,
              });
              const inputMutate = [
                {
                  id,
                  checkInStatus: original.checkInStatus,
                  hotelConfirmationCode: value,
                },
              ];

              const response = await mutateAsync({
                hotelSchedules: inputMutate,
              });

              notification.success({
                message: response.message,
              });
            } catch (e) {
              queryClient.setQueryData(queryKey, queryKey);
              notification.error({
                message: e.message,
              });
            } finally {
            }
          }, 3000)();
        }}
      />
    </div>
  );
}
